import { format } from 'owa-string-utils';
import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import { ONE_DRIVE_CONUSMER_API_URL } from 'owa-fileprovider-services';

const getFileInfoRequestUrlFormat: string = '{0}/v1.0/shares/{1}/driveItem';

export function getFileInfoRequestUrlOneDriveConsumer(url: string) {
    return format(
        getFileInfoRequestUrlFormat,
        ONE_DRIVE_CONUSMER_API_URL,
        getEncodedUrlForVroom(url)
    );
}
